import React, { createContext, useContext, useEffect, useState } from "react";
import { adminApi } from "@/lib/adminApi";

const AdminAuthCtx = createContext(null);

export const AdminAuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = localStorage.getItem("cit_admin_token");
    if (!t) { setLoading(false); return; }
    adminApi.get("/auth/me")
      .then((r) => setAdmin(r.data))
      .catch(() => localStorage.removeItem("cit_admin_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await adminApi.post("/auth/login", { email, password });
    localStorage.setItem("cit_admin_token", r.data.token);
    setAdmin(r.data.admin);
    return r.data.admin;
  };

  const logout = async () => {
    try { await adminApi.post("/auth/logout"); } catch { /* ignore */ }
    localStorage.removeItem("cit_admin_token");
    setAdmin(null);
  };

  return (
    <AdminAuthCtx.Provider value={{ admin, loading, login, logout }}>
      {children}
    </AdminAuthCtx.Provider>
  );
};

export const useAdminAuth = () => useContext(AdminAuthCtx);
